const months = [
  { number: 0, label: "Қаңтар" },
  { number: 1, label: "Ақпан" },
  { number: 2, label: "Наурыз" },
  { number: 3, label: "Сәуір" },
  { number: 4, label: "Мамыр" },
  // { number: 5, label: "Маусым" },
  // { number: 6, label: "Шілде" },
  // { number: 7, label: "Тамыз" },
  { number: 8, label: "Қыркүйек" },
  { number: 9, label: "Қазан" },
  { number: 10, label: "Қараша" },
  { number: 11, label: "Желтоқсан" },
];

export default function CalendarGrid({ selectedDate, onSelectDate }) {
  const currentYear = new Date().getFullYear();
  const selectedMonth = selectedDate.getMonth();

  const handleMonthSelect = (month) => {
    const newDate = new Date(currentYear, month, 1);
    onSelectDate(newDate);
  };

  return (
    <div className="grid grid-cols-3 gap-3">
      {months.map((month) => {
        const active = selectedMonth === month.number;
        return (
          <button
            key={month.number}
            onClick={() => handleMonthSelect(month.number)}
            aria-pressed={active}
            className={`w-full py-6 rounded-xl text-center font-semibold transition-all outline-none ${
              active
                ? "shadow-lg ring-2 ring-[#d6b94d]" // darker border highlight
                : "hover:bg-[#e9cf64]" // hover effect
            }`}
            style={{
              backgroundColor: active ? "#F3DA6D" : "#FEFCE8", // main yellow for active, pale yellow for default
              color: active ? "#1C1917" : "#854d0e", // dark text for contrast
            }}
          >
            {month.label}
          </button>
        );
      })}
    </div>
  );
}
